/* eslint-disable flowtype/require-valid-file-annotation */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Stepper, { Step, StepLabel } from 'material-ui/Stepper';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';

import AccountInfo from './accountinfo.js';
import BillingInfo from './billinginfo.js';
import DomainInfo from './domaininfo.js';
import Verification from './verify.js';
import Confirmation from './confirmation.js';

import ReactDOMServer from 'react-dom/server';

const styles = theme => ({
  root: {
    width: '90%',
  },
  backButton: {
    marginRight: theme.spacing.unit,
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
});

function getSteps() {
  return ['Account Information','Domain Information','Billing Information','Verification','Finished'];
}

class Signup extends React.Component {

  constructor(props){
    super(props);
    this.state = {activeStep: 0,
      step0:{fullName: props.fullName, clientName:props.clientName}
    };
  }

  handleNext = () => {
    const { activeStep } = this.state;
    var steps = getSteps();
    if(activeStep == (steps.length-1)){
      window.open("https://www.goldlasso.com/","_self","");
    } else {
      this.child.validateNow();
    }
  };

  handleBack = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep - 1,
    });
  };

  updateStep(data){
    const { activeStep } = this.state;
    if(activeStep==0){
      this.setState({step1:data});
    } else if(activeStep==1){
      this.setState({step2:data});
    } else if(activeStep==2){
      this.setState({step3:data});
    } else if(activeStep==3){
      this.setState({step4:data});
    }
    this.setState({
       activeStep: activeStep + 1,
    });
  }

  editStep(stepNo){
    this.setState({
       activeStep: stepNo
    });
  }

  render() {
    const { classes } = this.props;
    const steps = getSteps();
    const { activeStep } = this.state;

    var screen;

    if(this.state.activeStep==0){
      screen = <AccountInfo fields={this.state.step1} step0={this.state.step0} ref={instance => {this.child = instance;}} onSubmit={this.updateStep.bind(this)} />
    } else if(this.state.activeStep==1){
      screen = <DomainInfo fields={this.state.step2} ref={instance => {this.child = instance;}} onSubmit={this.updateStep.bind(this)} />
    } else if(this.state.activeStep==2){
      screen = <BillingInfo fields={this.state.step3} ref={instance => {this.child = instance;}} onSubmit={this.updateStep.bind(this)} />
    } else if(this.state.activeStep==3){
      var result = {
        ...this.state.step1,
        ...this.state.step2,
        ...this.state.step3,
      };
      screen = <Verification fields={result} ref={instance => {this.child = instance;}}
                onEdit={this.editStep.bind(this)}
                onSubmit={this.updateStep.bind(this)} />
    } else if(this.state.activeStep==4){
      var result = {
        ...this.state.step1,
        ...this.state.step2,
        ...this.state.step3,
      };
      var verString = ReactDOMServer.renderToStaticMarkup(<Verification fields={result} hideButton="true"  />);
      screen = <Confirmation fields={this.state.step4} ref={instance => {this.child = instance;}}
        emailString={verString}
        onSubmit={this.updateStep.bind(this)}/>
    }

    return (
      <div style={{marginTop:"20px"}}>
        <Stepper activeStep={activeStep} alternativeLabel>
          {steps.map(label => {
            return (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        <div style={{marginTop:"15px"}}>
          {this.state.activeStep === (steps.length-1) ? (
            <div>
              <div style={{textAlign:"left",width:"80%",margin:"0 auto"}}>
                {screen}
              </div>
              <br/>
              <Button raised color="primary" onClick={this.handleNext.bind(this)}>
                Close
              </Button>
            </div>
          ) : (
            <div>
              <div style={{textAlign:"left",width:"80%",margin:"0 auto"}}>
                {screen}
              </div>
              <br/>
              <div>
                <Button disabled={activeStep === 0} onClick={this.handleBack}
                  className={classes.backButton}>
                  Back
                </Button>
                <Button raised color="primary" onClick={this.handleNext.bind(this)}>
                  {activeStep === steps.length-2 ? 'Finish' : 'Next'}
                </Button>
              </div>
              <br/>
              <br/>
            </div>
          )}
        </div>
      </div>
    );
  }
}

Signup.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styles)(Signup);



// WEBPACK FOOTER //
// ./src/components/signup.js